import React from "react";

export default ({ children, label, right, sticky, full, className, header = false }) => {
  var cln = className + " pageblock ";
  if (header)
  {
    cln += " pageblock__header ";
  }
  return (
    <div className={cln}>
      {label ? <h3 className="pageblock__label">{label}</h3> : <span />}
      <div className="pageblock__content">{children}</div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/Page/PageBlock.jsx